import { gql } from '@apollo/client/core';

export const CreatePartner = gql`
  mutation ($data: PartnerCreateInput!) {
    createPartner(data: $data) {
      id
      BillingAccounts {
        id
      }
      Contracts {
        id
        modelType
        partnerType
      }
    }
  }
`;
